module.exports = __webpack_public_path__ + "static/media/logo.941c6f09.jpg";